import { render, staticRenderFns } from "./KycAdminFilters.vue?vue&type=template&id=70945db2&"
import script from "./KycAdminFilters.vue?vue&type=script&lang=js&"
export * from "./KycAdminFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports